module.exports = __webpack_public_path__ + "static/media/number-yellow-9.b7aafde9.png";